import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as deviceService from "../../../../devices/deviceService";
import * as validationService from "../../../../devices/add-device-modal/validationService";
import { sortObjectsByAlphabet } from "../../../../utils";
import SelectV2 from "../../../../view/SelectV2";

function DeviceTypeField({ deviceType, setDeviceType, valid, loadedDeviceTypes }) {
    const [deviceTypes, setDeviceTypes] = useState(loadedDeviceTypes || []);

    useEffect(() => {
        if (loadedDeviceTypes?.length) {
            setDeviceTypes(loadedDeviceTypes);
            return;
        }

        const loadDeviceTypes = async () => {
            const deviceTypesList = await deviceService.loadDeviceTypes();
            if (deviceTypesList && Array.isArray(deviceTypesList) && deviceTypesList.length) {
                setDeviceTypes(deviceTypesList);
            }
        }
        loadDeviceTypes();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (deviceTypeId) => {
        setDeviceType(deviceTypeId);
        if (deviceTypeId === "-1") {
            validationService.validateDeviceTypeSelected("", 'devicetype');
        } else {
            validationService.validateDeviceTypeSelected(deviceTypeId, 'devicetype');
        }
    };

    const deviceTypeCopy = sortObjectsByAlphabet(deviceTypes, 'name');
    const options = [
        { value: "-1", label: "Choose" },
        ...((deviceTypeCopy || []).map((device) => ({
            value: String(device.id),
            label: device.name
        })))
    ];

    return (
        <div className="target-type-wizard-field">
            <label htmlFor="deviceType" className="target-type-wizard-field__label">
                Device Type <span className="modal-v2-required-mark">*</span>
            </label>
            <SelectV2
                inputId="deviceType"
                className={`target-type-wizard-select ${valid ? "is-invalid" : ""}`}
                value={String(deviceType ?? "-1")}
                onChange={onChange}
                options={options}
                noOptionsMessage={() => "No device types available"}
            />
        </div>
    );
}

function mapStateToProps(state) {
    const validation = state.validation;
    const msbPageDeviceTypes = state.msbPage?.targetTypes?.deviceTypes || state.msbPage?.deviceTypes || [];
    const addRulesDeviceTypes = state.addRulesPage?.deviceTypes || [];
    const addDeviceModalDeviceTypes = state.addDeviceModal?.deviceTypes || [];

    return {
        valid: validation.devicetype,
        loadedDeviceTypes: msbPageDeviceTypes.length
            ? msbPageDeviceTypes
            : addRulesDeviceTypes.length
                ? addRulesDeviceTypes
                : addDeviceModalDeviceTypes
    }
}

export default connect(mapStateToProps)(DeviceTypeField);
